class ContactPanel4i {
    constructor() {
        this.allChatLinks = document.querySelectorAll(".initChat");
        this.hidden = false;
        this.openHide = null;
        this.openEmail = null;
        this.openChat = null;
        this.chatPromise = null;
        this.emailPromise = null;

        this.toggleHide = this.toggleHide.bind(this);
        this.onOpenEmailInitial = this.onOpenEmailInitial.bind(this);
        this.onOpenChatInitial = this.onOpenChatInitial.bind(this);
    }

    /**
     * Initializes the Contact Panel by fetching the contact form and binding events.
     */
    async init() {
        console.log("ContactPanel: initializing contact panel");
        await this.getContactHTML();
    }

    async getContactHTML() {
        try {
            const response = await fetch('/Chat/GetContactForm', {
                method: 'GET',
                credentials: 'same-origin',
                cache: 'no-cache',
            });

            const html = response.ok ? await response.text() : '';
            if (html) {
                this.injectContactForm(html);
                this.bindEvents();
                this.bindAllChatLinks();
                this.restoreChatState();
            } else {
                this.logError('ContactPanel: failed getting contact form', { Error: 'Form came back empty' });
                this.hideAllChatLinks();
            }
        } catch (error) {
            this.logError('ContactPanel: failed getting contact form', { Error: JSON.stringify(error) });
            this.hideAllChatLinks();
        }
    }
    
    /**
     * Injects the contact form HTML into the DOM.
     * @param {string} html - The contact form HTML.
     */
    injectContactForm(html) {
        const div = document.createElement('div');
        div.innerHTML = html;
        document.body.appendChild(div);

        this.openHide = document.querySelector('.iwc-contactPanel .iwc-openHide');
        this.openEmail = document.querySelector('.iwc-contactPanel .iwc-openEmail');
        this.openChat = document.querySelector('.iwc-contactPanel .iwc-openChat');
    }

    /**
     * Binds event listeners for the Contact Panel.
     */
    bindEvents() {
        this.openHide.addEventListener('click', this.toggleHide);
        this.openEmail.addEventListener('click', this.onOpenEmailInitial);
        this.openChat.addEventListener('click', this.onOpenChatInitial);
    }

    async onOpenEmailInitial(e) {
        e.preventDefault();
        // Remove the initial event handler. Will be handled in the email module.
        this.openEmail.removeEventListener('click', this.onOpenEmailInitial);
        const email = await this.loadEmail();
        email.toggle(e);
    }

    async onOpenChatInitial(e) {
        e.preventDefault();
        // Remove the initial event handlers. Will be handled in the chat module.
        this.openChat.removeEventListener('click', this.onOpenChatInitial);
        this.allChatLinks.forEach(element => {
            element.removeEventListener('click', this.onOpenChatInitial);
        });
        const chat = await this.loadChat();
        chat.toggle(e);
        chat.init();
    }

    /**
     * Hides all chat links.
     */
    hideAllChatLinks() {
        this.allChatLinks.forEach(element => {
            element.style.display = "none";
        });
    }

    /**
     * Binds click events to all chat links.
     */
    bindAllChatLinks() {
        this.allChatLinks.forEach(element => {
            element.addEventListener('click', this.onOpenChatInitial);
        });
    }

    /**
     * Restores the chat state from session storage.
     */
    restoreChatState() {
        const chatState = JSON.parse(localStorage.getItem('chatState'));

        if (this.openChat && chatState && chatState.status === 1 && !chatState.inPopout) {
            console.log("ContactPanel: restoring chat state", chatState);
            const isRecent = (new Date() - new Date(chatState.time)) <= 120000;
            isRecent ? this.openChat.click() : localStorage.removeItem('chatState');
        }
    }

    /**
     * Toggles the visibility of the Contact Panel.
     */
    toggleHide() {
        if (this.hidden) {
            this.openHide.querySelector('.hideLabel').classList.remove('hide');
            this.openHide.querySelector('.showLabel').classList.add('hide');
            this.openHide.querySelector("svg").setAttribute("class", "rotate180 show layoutCenter");
            this.openHide.classList.add('padding5');
            this.openHide.setAttribute('aria-expanded', 'true');
            this.openChat && this.openChat.querySelector('span').classList.remove('hide');
            this.openChat && this.openChat.classList.add('padding5');
            this.openChat && this.openChat.classList.remove('invisible');
            this.openEmail.querySelector('span').classList.remove('hide');
            this.openEmail.classList.add('padding5')
            this.openEmail.classList.remove('invisible');
        } else {
            this.openHide.querySelector('.hideLabel').classList.add('hide');
            this.openHide.querySelector('.showLabel').classList.remove('hide');
            this.openHide.querySelector("svg").setAttribute("class", "");
            this.openHide.classList.remove('padding5');
            this.openHide.setAttribute('aria-expanded', 'false');
            this.openChat && this.openChat.querySelector('span').classList.add('hide');
            this.openChat && this.openChat.classList.remove('padding5');
            this.openChat && this.openChat.classList.add('invisible');
            this.openEmail.querySelector('span').classList.add('hide');
            this.openEmail.classList.remove('padding5');
            this.openEmail.classList.add('invisible');
            if (document.getElementById("chatErrorMsg")) {
                document.getElementById("chatErrorMsg").innerHTML = '';
            }
        }

        this.hidden = !this.hidden;
    }

    /**
     * Logs an error message to the console or tracking service.
     * @param {string} message - The error message.
     * @param {Object} properties - Additional error properties.
     */
    logError(message, properties) {
        if (typeof appInsights !== 'undefined') {
            appInsights.trackTrace({
                message,
                properties,
                severityLevel: appInsights.SeverityLevel.Error,
            });
        }
    }

    async loadEmail() {
        if (!this.emailPromise) {
            this.emailPromise = import('./modules/email.js')
                .then(({ default: Email4i }) => {
                    Email4i.init();
                    return Email4i;
                })
                .catch((error) => {
                    console.error("Error in loadEmail: Failed to load Email4i:", error);
                    this.emailPromise = null; // Reset to allow retry
                    return null;
                });
        }

        return this.emailPromise;
    }

    async loadChat() {
        if (!this.chatPromise) {
            this.chatPromise = import('./modules/chat.js')
                .then(({ default: Chat4i }) => {
                    return Chat4i;
                })
                .catch((error) => {
                    console.error("Error in loadChat: Failed to load Chat4i:", error);
                    this.chatPromise = null; // Reset to allow retry
                    return null;
                });
        }

        return this.chatPromise;
    }
}

window.ContactPanel4i = new ContactPanel4i();
await window.ContactPanel4i.init();
export default new ContactPanel4i();